import React, { useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { defaultToastOptions, groupContext, openAddingToBucketMenu, openLoginMenu, setDTConfig, } from "../index.js";
import executeRequest from "../../../../../modules/request.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
import OfferTab from "../offerTab/offerTab.js";
import ZoomIcon from "../zoomIcon/zoomIcon.js";
import "./style.css";
export default function ImageHovered(props) {
    const group = useContext(groupContext);
    const renderTime = useRef();
    const { emit, state } = useGlobalUpdate(UpdateBasketItemsCount);
    const requiredData = {
        needsEmail: group.clientData.email,
        needsName: group.clientData.name,
        needsPhone: group.clientData.phone,
    };
    useEffect(() => {
        renderTime.current = Date.now();
    }, []);
    return (React.createElement("div", { className: "hovered-image-container " +
            (props.showHoverEffect === true || props.showHoverEffect === undefined ?
                " hovered-image-container-with-bg"
                : "") },
        React.createElement("div", { className: "hovered-image-zone merchant-zone" }, props.offers
            .filter((offer) => !offer["@hidden"])
            .map((offer, index) => (React.createElement(OfferTab, { key: index, name: offer.name, title: offer.title, onChoosed: async () => {
                var _a, _b;
                const deltaMs = Date.now() - ((_a = renderTime.current) !== null && _a !== void 0 ? _a : Date.now());
                // if (deltaMs < 15) return;
                const { status, isOrdered } = await executeRequest(`/api/public/users/gallery/orders/ordered?image=${props.imageName}&offer=${offer.name}`, "GET", {});
                if (status == 401) {
                    await new Promise((resolve, reject) => {
                        var _a, _b, _c;
                        openLoginMenu({
                            ...requiredData,
                            flow: (_a = group.flow) === null || _a === void 0 ? void 0 : _a.onFirstOrderIntent,
                            componentList: (_c = (_b = group.flow) === null || _b === void 0 ? void 0 : _b.componentsList) !== null && _c !== void 0 ? _c : {},
                            onLogin() {
                                setDTConfig((c) => ({ ...c, isLoggedIn: "true" }));
                                resolve();
                                emit(state + 1);
                            },
                            onExit() {
                                reject();
                                emit(state + 1);
                            },
                            allowLoginToOrder: group.allowLoginToOrder,
                        });
                    });
                }
                if (status === 409) {
                    toast.error("Zamówienie zostało już złożone i nie ma możliwości jego edytowania!", defaultToastOptions);
                    return;
                }
                if (isOrdered == true) {
                    toast.error("To zdjęcie zostało już dodane do koszyka", defaultToastOptions);
                    return;
                }
                (_b = props.onOfferSelect) === null || _b === void 0 ? void 0 : _b.call(props);
                openAddingToBucketMenu({
                    offer,
                    imageUrl: props.imageUrl,
                    imageName: props.imageName,
                    intentSource: props.intentSource,
                });
            } })))),
        !(props.showZoomButton === false) && (React.createElement("div", { className: "hovered-image-zone app-zone" },
            React.createElement("div", { className: "hovered-zoom-icon" },
                React.createElement(ZoomIcon, { imageUrl: props.imageUrl, openZoom: props.openZoom }))))));
}
